import React from 'react';
import style from './index.module.css';
import { IconRcAccountProcessSuccess } from '@/assets/account';
import { IconRcHiButtonLoading } from 'assets/hi';
import cx from 'clsx';
type ProcessStepsProps = {
  steps: { title: string; content: string }[];
  activeStepIndex: number;
  isLoading?: boolean;
};

export const ProcessSteps = ({ steps, activeStepIndex, isLoading }: ProcessStepsProps) => {
  return (
    <div className={style.stepProcess}>
      {steps.map((step, index) => (
        <div
          key={index}
          className={cx(
            style.stepItem,
            index === activeStepIndex ? style.isActive : null,
            index < activeStepIndex ? style.isFinished : null,
            isLoading && style.isLoading,
          )}>
          <div className={style.stepItemLeft}>
            <div className={cx(style.stepItemIcon, index)}>
              {index < activeStepIndex ? (
                <IconRcAccountProcessSuccess />
              ) : isLoading && index === activeStepIndex ? (
                <IconRcHiButtonLoading width={26} height={26} />
              ) : (
                index + 1
              )}
            </div>

            {index === steps.length - 1 ? null : <div className={style.stepItemLine}></div>}
          </div>

          <div className={style.stepItemRight}>
            <div className={style.title}>{step.title}</div>
            <div className={style.content}>{step.content}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
